import { render } from "./ListeTarificationPage.vue?vue&type=template&id=a17044d0&ts=true"
import script from "./ListeTarificationPage.vue?vue&type=script&lang=ts"
export * from "./ListeTarificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__